<template>
  <div>
    <div class="container-fluid">
      <div class="page-header">
        <div class="row">
          <div class="col-sm-6">
            <h3>{{$t("expertBenefits")}}</h3>
            <ol class="breadcrumb">
              <li class="breadcrumb-item"><a>{{$t("general")}}</a></li>
              <li class="breadcrumb-item active">{{$t("expertBenefits")}}</li>
            </ol>
          </div>
          <div class="col-sm-6">
            <!-- Bookmark Start-->
            <div class="bookmark">
              <ul>
                <li><a href="javascript:void(0)" data-container="body" data-bs-toggle="popover" data-placement="top"
                    title="" data-original-title="Tables"><i data-feather="inbox"></i></a></li>
                <li><a href="javascript:void(0)" data-container="body" data-bs-toggle="popover" data-placement="top"
                    title="" data-original-title="Chat"><i data-feather="message-square"></i></a></li>
                <li><a href="javascript:void(0)" data-container="body" data-bs-toggle="popover" data-placement="top"
                    title="" data-original-title="Icons"><i data-feather="command"></i></a></li>
                <li><a href="javascript:void(0)" data-container="body" data-bs-toggle="popover" data-placement="top"
                    title="" data-original-title="Learning"><i data-feather="layers"></i></a></li>
                <li><a href="javascript:void(0)"><i class="bookmark-search" data-feather="star"></i></a>
                  <form class="form-inline search-form">
                    <div class="form-group form-control-search">
                      <input type="text" :placeholder="$t('search') + '...'">
                    </div>
                  </form>
                </li>
              </ul>
            </div>
            <!-- Bookmark Ends-->
          </div>
        </div>
      </div>
    </div>
    <!-- Container-fluid starts-->
    <div class="container-fluid">
      <div class="col-md-12 p-0 project-list" v-show="$user.expert">
        <div class="card">
          <div class="row">
            <div class="col-md-6 p-0">
              <div class="mb-2">
                &nbsp;
              </div>
            </div>
            <div class="col-md-6 p-0">
              <div class="form-group mb-0 me-0"></div>
              <a v-if="myBenefit == null" class="btn btn-primary-light" @click="$router.push('/create-benefit')"> <plus-square-icon
                  class="custom-class"></plus-square-icon>{{$t("create_expertBenefit")}}</a>
              <a v-else class="btn btn-primary-light" @click="$router.push('/edit-benefit?expertBenefitId=' + myBenefit.id)"> <edit-icon
                  class="custom-class"></edit-icon>{{$t("edit_expertBenefit")}}</a>
            </div>
          </div>
        </div>
      </div>
      <div class="row job-search">
        <div class="col-md-6 col-lg-6 col-xl-4" v-for="benefit in benefits" :key="benefit.id">
          <div class="card">
            <div class="card-body">
              <div class="media"><img class="img-40 img-fluid m-r-20 rounded" :src="`/files/images/${benefit.imagesMap[$locale]}`" alt="">
                <div class="media-body">
                  <h6 class="f-w-600"><a :href="benefit.linksMap[$locale]" target="_blank">{{ benefit.tenantName }}</a>
                    <span class="badge badge-primary pull-right"><i class="fa fa-star"></i></span>
                  </h6>
                  <p>{{ $t("expert_status") }}</p>
                  <ul class="rating">
                    <li><i class="fa fa-star font-warning"></i></li>
                    <li><i class="fa fa-star font-warning"></i></li>
                    <li><i class="fa fa-star font-warning"></i></li>
                    <li><i class="fa fa-star font-warning"></i></li>
                    <li><i class="fa fa-star font-warning"></i></li>
                  </ul>
                </div>
              </div>
              <p>{{ benefit.descriptionsMap[$locale] }}</p>
              <button style="float: right;" @click="openLink(benefit.linksMap[$locale])" class="btn btn-primary" type="button"
                  data-bs-original-title="" title="">{{ $t("learn_more") }}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div style="position:absolute; bottom: 100px;left:50%;height:40px;width:40px "
      v-intersect.quiet="infiniteScrolling"></div>
    <!-- Container-fluid Ends-->

  </div>
</template>

<script>

import pagination from './custom/pagination.vue'
import { CalendarIcon,MapPinIcon, PlusSquareIcon, StarIcon, ClipboardIcon, FileTextIcon, TrashIcon, EditIcon } from 'vue-feather-icons'

export default {

  components: {
    MapPinIcon,
    PlusSquareIcon,
    ClipboardIcon,
    StarIcon,
    FileTextIcon,
    TrashIcon,
    EditIcon,
    CalendarIcon,
  },

  data() {
    return {
      page: 1,
      totalPages: 1,
      ElementPerPage: 50,
      sort: null,
      order: true,
      routes: {
        benefits: "/api/expertBenefit",
      },
      search: "",
      myBenefit: null,
      convertedTenants: [],
      tenantFilter: null,
      emailRules: [
        (v) => !!v || "E-mail is required",
        (v) =>
          /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
          "E-mail must be valid",
      ],
      rules: [(value) => !!value || this.$t("required")],
      benefits: [],
      roles: [],
      createTenantPopup: false,
      menu: false,
      createmode: true,

      // Personal Data
      me: null,
    };
  },

  watch: {
    menu(val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = "YEAR"));
    },
  },

  mounted() {
    this.fetchBenefits();
    this.fetchMyBenefit();
  },

  methods: {
    infiniteScrolling(entries, observer, isIntersecting) {
      if (isIntersecting) {
        setTimeout(() => {
          var _this = this;
          if (this.page < this.totalPages) {
            this.page++;
            this.$axios
              .get(this.routes.benefits, {
                params: {
                  sort: this.sort,
                  order: this.order ? "ASC" : "DESC",
                  page: this.page - 1,
                  size: this.ElementPerPage
                }
              })
              .then(function (response) {
                if (response.data.content.length > 1) {
                  response.data.content.forEach(item => _this.benefits.push(item));
                  _this.totalPages = response.data.totalPages;
                }
              })
              .catch(this.onError);
          }
        }, 500);
      }
    },
    previousPage() {
      this.page = this.page - 1;
      this.fetchBenefits();
    },
    nextPage() {
      this.page = this.page + 1;
      this.fetchBenefits();
    },
    openLink(link){
      window.open(link);
    },
    onError(err) {
      if (
        err.response != null &&
        err.response.data != null &&
        err.response.data.message != null
      ) {
        this.$noty.error(err.response.data.message);
      } else {
        console.error(err);
      }
    },
    fetchMyBenefit() {
      var _this = this;
      this.$axios
        .get("/api/expertBenefit/my")
        .then(function (response) {
          _this.myBenefit = response.data;
          _this.$forceUpdate();
        })
        .catch(() => {});
    },
    fetchBenefits(resetPage = false) {
      if (resetPage) this.page = 1;
      var _this = this;
      this.$axios
        .get(this.routes.benefits, {
          params: {
            search: _this.search,
            sort: _this.sort,
            order: _this.order ? "ASC" : "DESC",
            page: _this.page - 1,
            size: _this.ElementPerPage
          }
        })
        .then(function (response) {
          _this.benefits = response.data.content;
          _this.totalPages = response.data.totalPages;
          _this.$forceUpdate();
        })
        .catch(this.onError);
    },
    updatePage() {
      this.fetchBenefits();
    },
    updateVisibleBenefits() {
      var _this = this;
      this.benefits = this.benefits.slice(
        (_this.page = _this.ElementPerPage),
        (_this.page = _this.ElementPerPage) + _this.ElementPerPage
      );

      if (this.benefits.length == 0 && this.page > 0) {
        this.updatePage(this.page - 1);
      }
    },

    getJsonOptions() {
      const options = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      return options;
    },
  },
};
</script>

<style scoped>
.v-dialog>.v-card>.v-card__actions {
  padding: 8px 16px;
}
</style>

